import React, { Component } from 'react';
import {
  Stage,
  Layer,
  Line,
} from 'react-konva';
import './DrawingCanvas.scss';

class DrawingCanvas extends Component {
  handleMouseDown = () => {
    const {
      lines,
      setLines,
    } = this.props;
    const {
      currentStroke,
    } = this.props;
    this._drawing = true;
    // add line
    const newLine = {
      points: [],
      stroke: currentStroke.hex,
    };
    setLines([...lines, newLine]);
  };

  handleMouseMove = () => {
    const {
      lines,
      setLines,
    } = this.props;
    if (!this._drawing) {
      return;
    }
    const stage = this.stageRef.getStage();
    const point = stage.getPointerPosition();
    const lastLine = lines[lines.length - 1];
    lastLine.points = lastLine.points.concat([point.x, point.y]);
    // replace last
    lines.splice(lines.length - 1, 1, lastLine);
    setLines(lines.concat());
  };

  handleMouseUp = () => {
    this._drawing = false;
  };

  render() {
    const {
      lines,
      width,
      height,
      isDrawing,
    } = this.props;
    return (
      <Stage
        width={width}
        height={height}
        onContentMousedown={isDrawing ? this.handleMouseDown : null}
        onContentMousemove={isDrawing ? this.handleMouseMove : null}
        onContentMouseup={isDrawing ? this.handleMouseUp : null}
        onContentMouseleave={isDrawing ? this.handleMouseUp : null}
        ref={(node) => {
          this.stageRef = node;
        }}
      >
        <Layer>
          {lines.map((line, i) => (
            <Line
              key={i} // eslint-disable-line
              points={line.points}
              stroke={line.stroke}
              strokeWidth={6}
            />
          ))}
        </Layer>
      </Stage>
    );
  }
}

export default DrawingCanvas;
